module.exports = __webpack_public_path__ + "img/labels-3-d-mobile-fr@2x.3c5632ad.webp";